var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('back'),_vm._v(" "),(!_vm.start)?_c('div',{staticClass:"wh-block"},[_c('instructions')],1):_vm._e(),_vm._v(" "),(_vm.start)?_c('game'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }